import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Accordion } from 'components/accordion'
import Clickable from 'components/clickable'

export const InlineCounter = ({ count }) => (
  <span
    className={classNames('small', count ? 'text-light' : 'disabled')}
    style={{ position: 'absolute', top: 2, right: '0px' }}
  >
    {count}
  </span>
)

InlineCounter.propTypes = {
  count: PropTypes.number.isRequired,
}

export const FilterSection = ({
  open,
  title,
  children,
  collapsedContent,
  disabled,
}) => (
  <Accordion
    defaultOpen={open}
    collapsedContent={<div className="phxl">{collapsedContent}</div>}
    trigger={({ onClick, isOpen }) => (
      <Clickable
        className="phxl"
        onClick={onClick}
        disabled={disabled}
        style={{ width: '100%' }}
        aria-label={`Click to ${isOpen ? 'close' : 'open'} ${title} options`}
      >
        <div
          style={{
            float: 'left',
            fontSize: '12px',
            lineHeight: '15px',
            letterSpacing: '2px',
          }}
          className="h6 text-uppercase text-bold inline text-light"
        >
          {title}
        </div>
        <span
          aria-hidden
          style={{ float: 'right', paddingTop: '15px', fontSize: '15px' }}
          className={`fa text-light ${
            isOpen && !disabled ? 'fa-chevron-up' : 'fa-chevron-down'
          }`}
        />
      </Clickable>
    )}
  >
    <div className="phxl">{children}</div>
  </Accordion>
)

FilterSection.propTypes = {
  disabled: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  collapsedContent: PropTypes.node,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

FilterSection.defaultProps = {
  disabled: false,
  collapsedContent: '',
}
